// extracted by mini-css-extract-plugin
export var modalFooter = "_qf-0";